import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import type { ChecklistBlockConfiguration } from "models/interfaces/block-configurations/checklist-block-configuration";
import {
    blockConfigurationDefaultValuesFactory,
    BlockConfigurationRecord,
} from "models/view-models/block-configurations/block-configuration-record";
import { ChecklistItemRecord } from "models/view-models/block-configurations/checklist-item-record";

const defaultValues: ChecklistBlockConfiguration =
    blockConfigurationDefaultValuesFactory<ChecklistBlockConfiguration>({
        isNumbered: false,
        usesCustomStatuses: false,
        items: [],
    });

export class ChecklistBlockConfigurationRecord
    extends Record(defaultValues)
    implements ChecklistBlockConfiguration, BlockConfigurationRecord
{
    constructor(params?: Partial<ChecklistBlockConfiguration>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        params.items = RecordUtils.ensureRecords(
            params.items ?? [],
            ChecklistItemRecord
        );

        super(params);
    }

    public with(
        values: Partial<ChecklistBlockConfiguration>
    ): ChecklistBlockConfigurationRecord {
        return new ChecklistBlockConfigurationRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
